import apiConversation from 'api/conversation'
import { SET_USER_STATE_AFTER_CANCEL, CANCELLING_LINK, SET_CANCEL_LINK_ERRORS, RESET_CANCEL_LINK } from '../../../../types/conversations/plugins'

const paymentApi = apiConversation.plugins.payment

const updateState = (userId, userState) => (dispatch) =>
  dispatch({
    userId,
    userState,
    type: SET_USER_STATE_AFTER_CANCEL,
  })

const cancellingLink = (userId, cancellingLink = true) => ({
  userId,
  cancellingLink,
  type: CANCELLING_LINK,
})

const setCancelLinkErrors = (userId, errors = {}) => ({
  userId,
  errors,
  type: SET_CANCEL_LINK_ERRORS,
})

const resetPlugin = (userId) => ({
  userId,
  type: RESET_CANCEL_LINK,
})

const cancelLink = (user, orderId) => (dispatch) => {
  dispatch(cancellingLink(user.id))
  dispatch(setCancelLinkErrors(user.id))

  paymentApi
    .cancelLink({ userId: user._id, orderId })
    .then(({ data, status }) => {
      // Important! We're not cancelling url anymore, update state.
      dispatch(cancellingLink(user.id, false))

      if (status !== 200) {
        return dispatch(setCancelLinkErrors(user.id, data))
      }

      return dispatch(resetPlugin(user.id))
    })
    .catch((error) => {
      dispatch(cancellingLink(user.id, false))

      return dispatch(setCancelLinkErrors(user.id, { error: 'server-error' }))
    })
}

export default {
  cancelLink,
  updateState,
  resetPlugin
}
